import React from "react";
import { useSearchParams } from "react-router-dom";
import { Boxes, Trophy, Euro } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProveedoresTab } from "@/pages/maestros/ProveedoresTab";
import { ProductosTab } from "@/pages/maestros/ProductosTab";
import { RankingTab } from "@/pages/maestros/RankingTab";
import { GastoProveedorTab } from "@/pages/maestros/GastoProveedorTab";
import { useAuth } from "@/context/AuthContext";

const Header = ({ icon: Icon, title, subtitle }) => (
  <div>
    <h1 className="flex items-center gap-2 font-heading text-2xl font-bold tracking-tight">
      <Icon className="h-6 w-6 text-primary" /> {title}
    </h1>
    <p className="text-sm text-muted-foreground">{subtitle}</p>
  </div>
);

export default function ProveedoresPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const view = params.get("view") || "";
  const canSee = !!(user?.is_admin || user?.is_leadership);

  // Vistas propias (accesibles desde el menú lateral), no como pestañas
  if (canSee && view === "ranking") {
    return (
      <div className="space-y-5" data-testid="proveedores-page">
        <Header icon={Trophy} title="Ranking de proveedores" subtitle="Ranking de gasto por proveedor · Iteración 3" />
        <RankingTab />
      </div>
    );
  }
  if (canSee && view === "gasto") {
    return (
      <div className="space-y-5" data-testid="proveedores-page">
        <Header icon={Euro} title="Gasto por Proveedor" subtitle="Gasto por proveedor y tipo de servicio (viajes vendidos) · Iteración 3" />
        <GastoProveedorTab />
      </div>
    );
  }

  const tab = view === "productos" ? "productos" : "proveedores";
  const setTab = (v) => setParams(v === "productos" ? { view: "productos" } : {});

  return (
    <div className="space-y-5" data-testid="proveedores-page">
      <Header icon={Boxes} title="Listado de Proveedores" subtitle="Maestros de proveedores y productos · Iteración 3" />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="maestros-tabs">
          <TabsTrigger value="proveedores" data-testid="tab-proveedores">Listado de Proveedores</TabsTrigger>
          <TabsTrigger value="productos" data-testid="tab-productos">Catálogo de Servicios</TabsTrigger>
        </TabsList>
        <TabsContent value="proveedores" className="mt-4"><ProveedoresTab /></TabsContent>
        <TabsContent value="productos" className="mt-4"><ProductosTab /></TabsContent>
      </Tabs>
    </div>
  );
}
